// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { MaskedText, PlaceholderMaskedText, TextFormat } from "./text_mask_pb.js";
import { AttachmentType, AttachmentV2 } from "./attachment_pb.js";
import { MemberUser } from "./member_pb.js";
import { Attachment, SharedContentPreview } from "./message_content_pb.js";

/**
 * @generated from enum social.chat.entity.v2.MessageBodyType
 */
export const MessageBodyType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.MessageBodyType",
  [
    {no: 0, name: "MESSAGE_BODY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_BODY_TYPE_CONVERSATION", localName: "CONVERSATION"},
    {no: 2, name: "MESSAGE_BODY_TYPE_EVENT", localName: "EVENT"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageStatus
 */
export const MessageStatus = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.MessageStatus",
  [
    {no: 0, name: "MESSAGE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_STATUS_SENT", localName: "SENT"},
    {no: 2, name: "MESSAGE_STATUS_READ", localName: "READ"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.CursorDirection
 */
export const CursorDirection = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.CursorDirection",
  [
    {no: 0, name: "CURSOR_DIRECTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CURSOR_DIRECTION_IN_FRONT", localName: "IN_FRONT"},
    {no: 2, name: "CURSOR_DIRECTION_BEHIND", localName: "BEHIND"},
    {no: 3, name: "CURSOR_DIRECTION_BETWEEN", localName: "BETWEEN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Message
 */
export const Message = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.Message",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "body_type", kind: "enum", T: proto3.getEnumType(MessageBodyType) },
    { no: 3, name: "body", kind: "message", T: MessageBody },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageBody
 */
export const MessageBody = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageBody",
  () => [
    { no: 1, name: "conversation", kind: "message", T: MessageConversation, oneof: "body" },
    { no: 2, name: "event", kind: "message", T: MessageEvent, oneof: "body" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageEvent
 */
export const MessageEvent = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageEvent",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "format", kind: "enum", T: proto3.getEnumType(TextFormat) },
    { no: 3, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageConversation
 */
export const MessageConversation = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageConversation",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masked_text", kind: "message", T: MaskedText },
    { no: 3, name: "content", kind: "message", T: MessageContent },
    { no: 4, name: "sender", kind: "message", T: MessageSender },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(MessageStatus) },
    { no: 6, name: "flag", kind: "message", T: MessageFlag },
    { no: 7, name: "replied_message", kind: "message", T: Message },
    { no: 8, name: "attachment_type", kind: "enum", T: proto3.getEnumType(AttachmentType) },
    { no: 9, name: "attachment", kind: "message", T: AttachmentV2 },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageFlag
 */
export const MessageFlag = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageFlag",
  () => [
    { no: 1, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_forwarded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_time_displayed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageSender
 */
export const MessageSender = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageSender",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "displayed_as", kind: "enum", T: proto3.getEnumType(MessageSender_DisplayedAs) },
    { no: 4, name: "is_active_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageSender.DisplayedAs
 */
export const MessageSender_DisplayedAs = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.MessageSender.DisplayedAs",
  [
    {no: 0, name: "DISPLAYED_AS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISPLAYED_AS_SENDER", localName: "SENDER"},
    {no: 2, name: "DISPLAYED_AS_RECEIVER", localName: "RECEIVER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageContent
 */
export const MessageContent = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MessageContent",
  () => [
    { no: 1, name: "attachment", kind: "message", T: Attachment },
    { no: 2, name: "shared_content", kind: "message", T: SharedContentPreview },
    { no: 3, name: "replied_message", kind: "message", T: Message },
  ],
);

